import { BibliographyClass, CollectionFlag, Prefix } from '@/types'
import {
  defaultSystemCode,
  exists,
  GetOrderListSelectionDetail,
  GetOrderListSelectionDetailFromJSON,
  SystemCode,
  SystemCodeFromJSON
} from '@/api'

export const OrderListSelectionStatus = {
  Selection: '1',
  Reject: '2',
  Order: '3'
}
export type OrderListSelectionStatus = typeof OrderListSelectionStatus[keyof typeof OrderListSelectionStatus]

export interface GetOrderListSelection {
  id: number
  bibliographyId: number
  bibliographyClass: BibliographyClass
  prefix: Prefix
  searchType: SystemCode
  displayTitle: string
  displayAuthor: string
  displayPublisher: string
  displayClass: string
  marc: string
  orderTotalPrice: number
  result: string
  reason: SystemCode
  type: SystemCode
  processedBranchHoldingNumber: number
  processedBranchOrderNumber: number
  processedBranchSelectionNumber: number
  allBranchHoldingNumber: number
  allBranchOrderNumber: number
  allBranchSelectionNumber: number
  collectionFlag: CollectionFlag
  revision: number
  details: GetOrderListSelectionDetail[]
}

export function GetOrderListSelectionFromJSON(
  json: any
): GetOrderListSelection {
  return {
    id: exists(json, 'id') ? json.id : 0,
    bibliographyId: exists(json, 'bibliography_id') ? json.bibliography_id : 0,
    bibliographyClass: exists(json, 'bibliography_class')
      ? json.bibliography_class
      : BibliographyClass.Real,
    prefix: exists(json, 'prefix') ? json.prefix : Prefix.Set,
    searchType: exists(json, 'search_type')
      ? SystemCodeFromJSON(json.search_type)
      : defaultSystemCode(),
    displayTitle: exists(json, 'display_title') ? json.display_title : '',
    displayAuthor: exists(json, 'display_author') ? json.display_author : '',
    displayPublisher: exists(json, 'display_publisher')
      ? json.display_publisher
      : '',
    displayClass: exists(json, 'display_class') ? json.display_class : '',
    marc: exists(json, 'marc') ? json.marc : '',
    orderTotalPrice: exists(json, 'order_total_price')
      ? json.order_total_price
      : 0,
    result: exists(json, 'result') ? json.result : '',
    reason: exists(json, 'reason')
      ? SystemCodeFromJSON(json.reason)
      : defaultSystemCode(),
    type: exists(json, 'type')
      ? SystemCodeFromJSON(json.type)
      : defaultSystemCode(),
    processedBranchHoldingNumber: exists(
      json,
      'processed_branch_holding_number'
    )
      ? json.processed_branch_holding_number
      : 0,
    processedBranchOrderNumber: exists(json, 'processed_branch_order_number')
      ? json.processed_branch_order_number
      : 0,
    processedBranchSelectionNumber: exists(
      json,
      'processed_branch_selection_number'
    )
      ? json.processed_branch_selection_number
      : 0,
    allBranchHoldingNumber: exists(json, 'all_branch_holding_number')
      ? json.all_branch_holding_number
      : 0,
    allBranchOrderNumber: exists(json, 'all_branch_order_number')
      ? json.all_branch_order_number
      : 0,
    allBranchSelectionNumber: exists(json, 'all_branch_selection_number')
      ? json.all_branch_selection_number
      : 0,
    collectionFlag: exists(json, 'collection_flag')
      ? json.collection_flag
      : CollectionFlag.NotCollection,
    revision: exists(json, 'revision') ? json.revision : 0,
    details: exists(json, 'details')
      ? json.details.map(GetOrderListSelectionDetailFromJSON)
      : []
  }
}
